import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import axiosInstance from "utils/axiosInstance";
import { useLocalStorage } from "utils/storage";
import { setUserData } from "services/auth";

const Register = () => {
    sessionStorage.clear();

    const navigate = useNavigate();

    const [token, setToken] = useLocalStorage('token');

    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        invite_token: "",
    });
    const [error, setError] = useState("");

    const handleInputChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await axiosInstance.post("/api/auth/register", form);

            setToken(response.data.token);
            setUserData(response.data);

            navigate("/notches");
        } catch (err) {
            setError(err.response?.data?.message || "Registration failed.");
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
            <div className="w-100" style={{ maxWidth: "400px" }}>
                <div className="card shadow-lg p-4">
                    <h3 className="text-center mb-4">Register</h3>
                    <form onSubmit={handleRegister}>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                className="form-control"
                                value={form.name}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="form-control"
                                value={form.email}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                className="form-control"
                                value={form.password}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="invite_token" className="form-label">
                                Invite Token
                            </label>
                            <input

                                type="text"
                                id="invite_token"
                                name="invite_token"
                                className="form-control"
                                value={form.invite_token}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        {error && (
                            <div className="alert alert-danger text-center" role="alert">
                                {error}
                            </div>
                        )}
                        <button type="submit" className="btn btn-primary w-100 py-2">
                            Register
                        </button>
                    </form>
                    <p className="text-center mt-3">
                        Already have an account? <Link to="/login">Login</Link>
                    </p>

                </div>
            </div>
        </div>
    );
};

export default Register;
